module.exports = __webpack_public_path__ + "images/e72772b00c325bf2442bfb2d341c717a.jpg";